<template>
  <card>
    <list
      v-if="$store.state.user.sections['clients']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "season",
      fields: [
        {
          label: "Номер телефона",
          key: "phone",
          type: "mask",
          mask: "+998#########",
          default: "+998",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_client",
      itemLink: "clients",
      setLink: "clients",
      columns: [
        {
          key: "id",
          title: "id",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "phone",
          title: "Номер телефона",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "full_name",
          title: "ФИО",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
